import React, { useEffect, useState } from "react";

import { useLocation } from "react-router-dom";

const MayRenderNav = ({ children }) => {
  const location = useLocation();
  const [showNavbar, setShowNavbar] = useState(false);

  useEffect(() => {
    if (location.pathname === "/login") {
      setShowNavbar(false);
    } else if (location.pathname === "/otp") {
      setShowNavbar(false);
    } else if (location.pathname === "/patientregisteration") {
      setShowNavbar(false);
    } else if (location.pathname === "/login") {
      setShowNavbar(false);
    } else if (location.pathname === "/otp") {
      setShowNavbar(false);
    } else if (location.pathname === "/therapistregisteration") {
      setShowNavbar(false);
    } else if (location.pathname === "/therapistcompleteprofile") {
      setShowNavbar(false);
    } else {
      setShowNavbar(true);
    }
  }, [location]);

  return <div>{showNavbar && children}</div>;
};

export default MayRenderNav;
